const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/workItemActions.ts';
import { KisApiAction, kisapiActionTypes } from '../defs/actionTypes';
import { KISAPI as API } from '../middleware/kisapi';
import { apiLoadWorkItems, apiSaveSignedPDF } from '@cistec/common_web/actions/kisapi/workItems';

export const atSaveSignedPDF = kisapiActionTypes('COMMON_SAVE_SIGNED_PDF');
export const atLoadWorkItemsToSign = kisapiActionTypes('COMMON_LOAD_WORKITEMSTOSIGN');

/**
 * Action to load a workItems with connections to PDF's to get signed
 * @param rkat Receiver category
 * @param rkey Receiver key
 * @param patnr
 */
export function loadWorkItemsToSign(rkat: string, rkey: string, patnr: string = '') {
    return {
        type: atLoadWorkItemsToSign.combined,
        [API]: apiLoadWorkItems(
            patnr,
            undefined,
            undefined,
            rkat,
            rkey,
            undefined,
            undefined,
            'U',
            'WKFMUNT01',
            undefined,
            undefined,
            undefined
        ),
        meta: { rkat, rkey },
    };
}

export type LoadWorkItemsToSignAction = KisApiAction<typeof loadWorkItemsToSign>;

export function actionSaveSignedPDF(workid: string, signedPdf: string) {
    return {
        type: atSaveSignedPDF.combined,
        [API]: apiSaveSignedPDF(workid, signedPdf),
        meta: { workid, signedPdf },
    };
}

export type SaveSignedPDFAction = KisApiAction<typeof actionSaveSignedPDF>;
